export default {"src":"/_next/static/media/whypod-icon1.489362e5.svg","height":38,"width":60};